module.exports = __webpack_public_path__ + "img/10blue.883084c6.png";